import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import Sidebar from '../Core/Sidebar';
import Navbar from '../Core/Navbar';
import { Search, Filter, Download, Calendar, ArrowUpRight, CreditCard } from 'lucide-react';
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';
import '../../Dashboard Style/WalletTransaction.css'; // Reusing your existing CSS
import { getWalletTransactionsApi } from '../../Services/Operations/ProductAPI';

const CMDBonus = ({ title, incomeType }) => {
  const authToken = useSelector((state) => state.user?.token);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(15);
  const [searchQuery, setSearchQuery] = useState('');
  const [dateFilter, setDateFilter] = useState('all');
  const [originalTransactions, setOriginalTransactions] = useState([]);

      const [isMobile, setIsMobile] = useState(false);
  
    // Check screen size on mount and resize
    useEffect(() => {
      const checkMobile = () => {
        const mobile = window.innerWidth < 992;
        setIsMobile(mobile);
  
        // Auto-close sidebar on mobile by default
        if (mobile) {
          setSidebarOpen(true);
        } else {
          setSidebarOpen(true);
        }
      };
  
      checkMobile();
      window.addEventListener('resize', checkMobile);
      return () => window.removeEventListener('resize', checkMobile);
    }, []);
  
  
  
    const closeSidebar = () => {
      if (isMobile) {
        setSidebarOpen(false);
      }
    };

  

  const toggleSidebar = () => {
      setSidebarOpen(!sidebarOpen);
    };
  
    // Initialize sidebar functionality (same as in Dashboard)
    useEffect(() => {
      const sidebar = document.querySelector('.sidebar');
      const sidebarBody = document.querySelector('.sidebar-body');
      
      if (sidebar) {
        if (sidebarOpen) {
          sidebar.classList.remove('close');
        } else {
          sidebar.classList.add('close');
        }
      }
      
      // Add custom scrollbar to sidebar body
      if (sidebarBody) {
        sidebarBody.style.height = 'calc(100vh - 70px)';
        sidebarBody.style.overflowY = 'auto';
      }
  
      return () => {
        // Cleanup
      };
    }, [sidebarOpen]);
  
    useEffect(() => {
      // Add custom scrollbar styles for sidebar
      const style = document.createElement('style');
      style.innerHTML = `
        /* Custom scrollbar for sidebar */
        .sidebar-body {
          height: calc(100vh - 70px);
          overflow-y: auto;
        }
        
        .sidebar-body::-webkit-scrollbar {
          width: 6px;
        }
        
        .sidebar-body::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 10px;
        }
        
        .sidebar-body::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 10px;
        }
        
        .sidebar-body::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.3);
        }
        
        /* Sidebar dropdown menu styles */
        .sidebar .nav-dropdown {
          list-style: none;
          padding-left: 0;
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease;
        }
        
        .sidebar .nav-dropdown.show {
          max-height: 500px;
        }
        
        .sidebar .nav-dropdown-item {
          padding-left: 2.5rem;
        }
        
        /* Sidebar dropdown toggle with icon */
        .nav-item.has-dropdown .nav-link {
          position: relative;
          padding-right: 2.5rem;
        }
        
        .nav-item.has-dropdown .dropdown-icon {
          position: absolute;
          right: 1rem;
          top: 50%;
          transform: translateY(-50%);
          transition: transform 0.3s ease;
        }
        
        .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
          transform: translateY(-50%) rotate(180deg);
        }
        
        /* Improved dropdown styling similar to first image */
        .nav-item.has-dropdown .nav-dropdown {
          background: rgba(255, 255, 255, 0.05);
          border-left: 3px solid var(--primary-color, #0d6efd);
          margin-left: 1rem;
          border-radius: 0 0 8px 8px;
        }
        
        .nav-item.has-dropdown .nav-dropdown-item .nav-link {
          padding: 0.75rem 1rem 0.75rem 2rem;
          color: rgba(255, 255, 255, 0.8);
        }
        
        .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
          background: rgba(255, 255, 255, 0.1);
          color: white;
        }
        
        /* Fix for category text styling */
        .nav-item.has-dropdown .link-title.nav-item.nav-category {
          font-weight: 600;
          font-size: 0.875rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        /* Smooth transitions */
        .sidebar {
          transition: all 0.3s ease;
        }
      `;
      document.head.appendChild(style);
  
      return () => {
        document.head.removeChild(style);
      };
    }, []);

  // const fetchIncomeData = async () => {
  //   try {
  //     setLoading(true);
  //     const response = await fetch(`https://global.thewillowquantum.com/api/user/get-wallet-transaction`, {
  //       method: 'POST',
  //       headers: {
  //         'Authorization': `Bearer ${authToken}`,
  //         'Content-Type': 'application/x-www-form-urlencoded',
  //       },
  //       body: new URLSearchParams({
  //         wallet_type: incomeType, // Dynamic based on route
  //         per_page: perPage.toString(),
  //         page: currentPage.toString()
  //       })
  //     });

  //     const data = await response.json();
  //     if (data.status) {
  //       setTransactions(data.data || []);
  //       setTotalPages(data.pagination?.last_page || 1);
  //     } else {
  //       toast.error(data.message || `Failed to fetch ${title}`);
  //     }
  //   } catch (error) {
  //     toast.error("Connection Error");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchIncomeData = async () => {
    try {
        setLoading(true);
        
        const result = await getWalletTransactionsApi(authToken, incomeType, {
            per_page: perPage,
            page: currentPage
        });

        if (result.status) {
            setTransactions(result.data);
            setOriginalTransactions(result.data);
            setTotalPages(result.pagination?.last_page || 1);
        } else {
            toast.error(result.message || `Failed to fetch ${title}`);
        }
    } catch (error) {
        console.error("Error fetching wallet transactions:", error);
        toast.error("Connection Error");
    } finally {
        setLoading(false);
    }
};

    const handleDateFilterChange = (filter) => {
      setDateFilter(filter);
      setCurrentPage(1);
      toast.info(`Date filter changed to ${filter === 'all' ? 'All Time' : filter}`);
    };

      const handleSearch = (e) => {
    e.preventDefault();
    // Search is handled by filteredTransactions memo
  };

   const filteredTransactions = useMemo(() => {
      let filtered = [...originalTransactions];
  
      // Apply search filter
      if (searchQuery.trim()) {
        const query = searchQuery.toLowerCase();
        filtered = filtered.filter(transaction => 
          transaction.transaction_id?.toString().toLowerCase().includes(query) ||
          transaction.from_user_email?.toLowerCase().includes(query) ||
          transaction.transaction_type?.toLowerCase().includes(query) ||
          transaction.opening_bal?.toString().includes(query) ||
          transaction.credit_bal?.toString().includes(query) ||
          transaction.debit_bal?.toString().includes(query) ||
          transaction.closing_bal?.toString().includes(query)
        );
      }
  
      // Apply date filter
      if (dateFilter !== 'all') {
        const now = new Date();
        filtered = filtered.filter(transaction => {
          const transactionDate = new Date(transaction.created_at);
          
          switch (dateFilter) {
            case 'today':
              return transactionDate.toDateString() === now.toDateString();
            
            case 'week': {
              const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
              return transactionDate >= oneWeekAgo;
            }
            
            case 'month': {
              const oneMonthAgo = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
              return transactionDate >= oneMonthAgo;
            }
            
            case 'year': {
              const oneYearAgo = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
              return transactionDate >= oneYearAgo;
            }
            
            default:
              return true;
          }
        });
      }
  
      return filtered;
    }, [originalTransactions, searchQuery, dateFilter]);
  

  useEffect(() => { fetchIncomeData(); }, [currentPage, perPage, incomeType]);

  const filteredData = useMemo(() => {
    let filtered = [...transactions];
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      filtered = filtered.filter(t => t.transaction_id?.toString().includes(q) || t.from_user_email?.toLowerCase().includes(q));
    }
    return filtered;
  }, [transactions, searchQuery]);

  const handleDownload = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Report');
    XLSX.writeFile(wb, `${title}_Report.xlsx`);
    toast.success("Report Exported");
  };

  return (
      <div className="main-wrapper dark-theme">
      {/* Sidebar */}
      <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
        <div className="sidebar-header">
          <a href="#" className="sidebar-brand">
            <i className="me-2" data-lucide="atom"></i>
            Willow <span>Quantum</span>
          </a>
          <div className="sidebar-toggler" onClick={toggleSidebar}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <Sidebar
                   isOpen={!sidebarOpen}
                   onClose={closeSidebar}
                 />
       
                 {/* Mobile backdrop */}
                 {isMobile && sidebarOpen && (
                   <div
                     className="sidebar-backdrop"
                     onClick={closeSidebar}
                   />
                 )}
      </nav>

      <div className="page-wrapper">
        <Navbar toggleSidebar={toggleSidebar}  isSidebarOpen={sidebarOpen}
            isMobile={isMobile}/>

        <div className="page-content p-4">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h3 className="text-white">{title}</h3>
          </div>

         <div className="row mb-4">
                      <div className="col-md-8">
                        <div className="d-flex gap-3 search-filter">
                          <form onSubmit={handleSearch} className="flex-grow-1">
                            <div className="search-box">
                              <Search size={18} className="search-icon" />
                              <input
                                type="text"
                                className="search-input"
                                placeholder="Search by transaction ID, email, or amount..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                              />
                              {/* <button type="submit" className="search-btn">
                                Search
                              </button> */}
                            </div>
                          </form>
                          <div className="dropdown">
                            <button
                              className="btn btn-outline-light dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                            >
                              <Filter size={16} className="me-2" />
                              {dateFilter === 'all' ? 'Filter by Date' : dateFilter.charAt(0).toUpperCase() + dateFilter.slice(1)}
                            </button>
                            <div className="dropdown-menu">
                              <button 
                                className={`dropdown-item ${dateFilter === 'today' ? 'active' : ''}`}
                                onClick={() => handleDateFilterChange('today')}
                              >
                                Today
                              </button>
                              <button 
                                className={`dropdown-item ${dateFilter === 'week' ? 'active' : ''}`}
                                onClick={() => handleDateFilterChange('week')}
                              >
                                This Week
                              </button>
                              <button 
                                className={`dropdown-item ${dateFilter === 'month' ? 'active' : ''}`}
                                onClick={() => handleDateFilterChange('month')}
                              >
                                This Month
                              </button>
                              <button 
                                className={`dropdown-item ${dateFilter === 'year' ? 'active' : ''}`}
                                onClick={() => handleDateFilterChange('year')}
                              >
                                This Year
                              </button>
                              <div className="dropdown-divider"></div>
                              <button 
                                className={`dropdown-item ${dateFilter === 'all' ? 'active' : ''}`}
                                onClick={() => handleDateFilterChange('all')}
                              >
                                All Time
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="d-flex export-page gap-2">
                          <button 
                            className="btn btn-outline-light"
                            onClick={handleDownload}
                            disabled={filteredTransactions.length === 0}
                          >
                            <Download size={16} className="me-2" />
                            Export ({filteredTransactions.length})
                          </button>
                          <div className="dropdown">
                            <button
                              className="btn btn-outline-light dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                            >
                              {perPage} per page
                            </button>
                            <div className="dropdown-menu">
                              {[10, 15, 25, 50, 100].map((num) => (
                                <button
                                  key={num}
                                  className={`dropdown-item ${perPage === num ? 'active' : ''}`}
                                  onClick={() => {
                                    setPerPage(num);
                                    toast.info(`Displaying ${num} transactions per page`);
                                  }}
                                >
                                  {num} per page
                                </button>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

          <div className="transaction-table-wrapper">
            {loading ? (
              <div className="text-center py-5"><div className="spinner-border text-light"></div></div>
            ) : (
              <div className="table-responsive">
                <table className="transaction-table">
                  <thead>
                    <tr>
                      <th>Transaction ID</th>
                      <th>Type</th>
                      <th>From/To</th>
                      <th>Opening</th>
                      <th>Amount</th>
                      <th>Closing</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.map((t) => (
                      <tr key={t.id}>
                        <td>#{t.transaction_id}</td>
                        <td className="text-info"><CreditCard size={14} className="me-1"/> {t.transaction_type}</td>
                        <td>{t.from_user_email || 'System'}</td>
                        <td>${parseFloat(t.opening_bal).toFixed(2)}</td>
                        <td className={t.credit_bal > 0 ? "text-green" : "text-red"}>
                            {t.credit_bal > 0 ? `+$${t.credit_bal}` : `-$${t.debit_bal}`}
                        </td>
                        <td>${parseFloat(t.closing_bal).toFixed(2)}</td>
                        <td><Calendar size={14}/> {new Date(t.created_at).toLocaleDateString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
         <footer className="footer-dark">
          <div className="container">
            <p className="text-center mb-0 text-white">
              Copyright © 2025 Willow Quantum. All rights reserved.
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default CMDBonus;